
$("#wr-owl-carousel").owlCarousel({lazyLoad:true,slideSpeed:300,paginationSpeed:400,singleItem:true,items:1,loop:true,autoplay:true,autoplayTimeout:5000,autoplayHoverPause:true,autoHeight:false,});